<div mat-dialog-title class="dialog-title">
    <h3>Bekräfta</h3>
    <button mat-icon-button aria-label="Stäng dialog" mat-dialog-close><mat-icon>close</mat-icon></button>
</div>
<mat-dialog-content>{{ data.text }}</mat-dialog-content>
<mat-dialog-actions class="action-bar">
    <button mat-flat-button color="primary" id="confirm-modal-button" (click)="confirm()">Ok</button>
    <button mat-stroked-button [mat-dialog-close]="true" id="cancel-modal-button" >Avbryt</button>
</mat-dialog-actions>